//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';


//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

//  -- Example ------------------------
const feedbackform = {
    isLoading: false,
    teacherDescription: null,
    teacherName: null,
    audioUrl: null,
    email: null,
    autoSubmit: false,
    reportResult: null,
};
const feedbackInitial = {
    feedback: {},
    isLoading: false,
};

export const feedbackForm = (state = feedbackform, action) => {
    switch (action.type) {
        case ActionTypes.feedback.invokeFeedback:
            return ({ ...state, isLoading: true, teacherDescription: null, teacherName: null, audioUrl: null, email: null, autoSubmit: false });
        case ActionTypes.feedback.invokeFeedbackWithTeacherDescription:
            return ({ ...state, isLoading: true, teacherDescription: action.payload.teacherDescription, teacherName: action.payload.teacherName, audioUrl: action.payload.audioUrl || null, email: action.payload.email || null, autoSubmit: true });
        case ActionTypes.feedback.revokeFeedback:
            return ({ ...state, isLoading: false, teacherDescription: null, teacherName: null, audioUrl: null, email: null, autoSubmit: false, reportResult: null });
        case ActionTypes.feedback.setFeedbackReportResult:
            return ({ ...state, reportResult: action.payload });
        case ActionTypes.feedback.clearFeedbackReportResult:
            return ({ ...state, reportResult: null });
        default:
            return state;
    }
};

export const feedback = (state = feedbackInitial, action) => {
    switch (action.type) {
        case ActionTypes.feedback.createFeedback:
            return ({ ...state, feedback: {}, isLoading: true });
        case ActionTypes.feedback.createFeedbackSuccess:
            return ({ ...state, feedback: action.payload , isLoading: false });
        default:
            return state;
    }
};
